export default "__VITE_ASSET__b0a7431d__"